import { ReactNode } from 'react'

import { Money, StatusBadge } from '@/components/ds'
import { Skeleton } from '@/components/ui/skeleton'
import { TableCell, TableRow } from '@/components/ui/table'
import { EshopMethodPrice } from '@/interfaces/eshop'

/** Ceny způsobu dopravy nebo platby, každá měna na vlastním řádku. */
export const EshopPrices = ({ prices, empty = 'Bez poplatku' }: { prices: EshopMethodPrice[]; empty?: ReactNode }) => {
  if (prices.length === 0) return <span className="text-muted-foreground">{empty}</span>
  return (
    <div className="flex flex-col items-end gap-0.5">
      {prices.map((price, i) => (
        <div key={i} className="flex flex-col items-end">
          <Money amount={price.price.amount} currency={price.price.currency} />
          {price.freeFromThreshold && (
            <span className="inline-flex items-baseline gap-1 text-xs text-muted-foreground">
              zdarma od
              <Money
                amount={price.freeFromThreshold.amount}
                currency={price.freeFromThreshold.currency}
                size="sm"
                className="font-normal text-muted-foreground"
              />
            </span>
          )}
        </div>
      ))}
    </div>
  )
}

export const EnabledBadge = ({ enabled }: { enabled: boolean }) =>
  enabled ? <StatusBadge status="paid" label="Aktivní" /> : <StatusBadge status="draft" label="Vypnuto" />

/** `mobileCols` jsou indexy sloupců viditelných i na telefonu, ostatní se ukážou až od md. */
export const SkeletonRows = ({ rows = 4, cols, mobileCols }: { rows?: number; cols: number; mobileCols?: number[] }) => (
  <>
    {Array.from({ length: rows }).map((_, i) => (
      <TableRow key={i}>
        {Array.from({ length: cols }).map((__, j) => (
          <TableCell key={j} className={mobileCols && !mobileCols.includes(j) ? 'hidden md:table-cell' : undefined}>
            <Skeleton className="h-4 w-full max-w-32" />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
)
